var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2", on: { click: _vm.toOrder } }, [
                _vm._v("填写退货详情"),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "basic" }, [
      _c("p", { staticClass: "header" }, [_vm._v("订单信息")]),
      _c("ul", { staticClass: "ul" }, [
        _c("li", [
          _c("p", [
            _vm._v("订单编号：" + _vm._s(_vm.tableData.orderUser.orderIdStr)),
          ]),
          _c("p", [
            _vm._v("订单状态： " + _vm._s(_vm.tableData.orderUser.orderType)),
          ]),
          _c("p", [
            _vm._v("时 间 ：" + _vm._s(_vm.tableData.orderUser.createdTime)),
          ]),
          _c("p", [
            _vm._v("客服：" + _vm._s(_vm.tableData.orderUser.employeeName)),
          ]),
        ]),
        _c("li", [
          _c("span", [_vm._v("客户信息 ：")]),
          _c("span", [
            _vm._v(_vm._s(_vm.tableData.orderUser.customerUserName)),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.tableData.orderUser.customerUserPhone)),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.orderUser.detailedAddress))]),
        ]),
        _c("li", [
          _c("span", [_vm._v("收货信息 ：")]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.orderUser.addressName))]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.orderUser.addressPhone))]),
          _c("span", [_vm._v(_vm._s(_vm.tableData.orderUser.address))]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "goods" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("商品详情")]),
        _c("span", [_vm._v(" 商品 ")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData.orderCommodityList, align: "center" },
          },
          [
            _c("el-table-column", {
              attrs: { label: "品牌", prop: "brandName" },
            }),
            _c("el-table-column", {
              attrs: { label: "商品名称", prop: "name" },
            }),
            _c("el-table-column", {
              attrs: { label: "原订单数", prop: "number" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "可退回数量",
                "min-width": "90px",
                prop: "waitNumber",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "退货数量", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          size: "mini",
                          max: scope.row.waitNumber,
                          label: "描述文字",
                        },
                        model: {
                          value: scope.row.numberC,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "numberC", $$v)
                          },
                          expression: "scope.row.numberC",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", { attrs: { label: "单价", prop: "price" } }),
            _c("el-table-column", {
              attrs: { label: "规格", prop: "specificationName" },
            }),
            _c("el-table-column", { attrs: { label: "小计", prop: "total" } }),
          ],
          1
        ),
        _c("span", [_vm._v(" 赠品 ")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData.orderComplimentaryList,
              align: "center",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "品牌", prop: "brandName" },
            }),
            _c("el-table-column", {
              attrs: { label: "商品名称", prop: "complimentaryName" },
            }),
            _c("el-table-column", {
              attrs: { label: "原订单数", prop: "number" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "可退回数量",
                "min-width": "90px",
                prop: "waitNumber",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "退货数量", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          size: "mini",
                          max: scope.row.waitNumber,
                          label: "描述文字",
                        },
                        model: {
                          value: scope.row.numberC,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "numberC", $$v)
                          },
                          expression: "scope.row.numberC",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", { attrs: { label: "单价", prop: "price" } }),
            _c("el-table-column", {
              attrs: { label: "规格", prop: "specificationName" },
            }),
            _c("el-table-column", { attrs: { label: "小计", prop: "total" } }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "total" }, [
      _c("div", { staticClass: "before" }, [
        _c("p", [_vm._v("原单总计")]),
        _c("p", [_vm._v("共 " + _vm._s(_vm.totalCout(0)) + " 件")]),
        _c("p", [_vm._v("运费：￥" + _vm._s(_vm.tableData.orderUser.charge))]),
        _c("p", [_vm._v("赠品总价： ￥0")]),
        _c("p", [
          _vm._v("商品总价：￥" + _vm._s(_vm.tableData.orderUser.total)),
        ]),
        _c("p", [
          _vm._v("应收金额：￥" + _vm._s(_vm.tableData.orderUser.total)),
        ]),
        _c("p", [
          _vm._v(
            "已收金额：￥" + _vm._s(_vm.tableData.orderUser.receivedMoney)
          ),
        ]),
        _c("p", [_vm._v("代收金额：￥0")]),
      ]),
      _c("div", { staticClass: "back" }, [
        _c("p", [_vm._v("退货总计")]),
        _c("p", [_vm._v("共 " + _vm._s(_vm.totalCout(1)) + " 件")]),
      ]),
      _c("div", { staticClass: "deal" }, [
        _c("p", [
          _vm._v(
            "已收金额： ￥" + _vm._s(_vm.tableData.orderUser.receivedMoney)
          ),
        ]),
        _c("p", [
          _vm._v(
            "已退总金额: ￥" + _vm._s(_vm.tableData.orderUser.returnMoneyAll)
          ),
        ]),
        _c("div", [
          _vm._m(0),
          _c(
            "p",
            [
              _c("el-input-number", {
                staticStyle: { width: "100px" },
                attrs: {
                  min: 0,
                  max: _vm.tableData.orderUser.receivedMoney,
                  controls: false,
                },
                model: {
                  value: _vm.salay,
                  callback: function ($$v) {
                    _vm.salay = $$v
                  },
                  expression: "salay",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "notes" }, [
      _c("p", { staticClass: "header" }, [_vm._v("备注")]),
      _c(
        "div",
        [
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请输入需要备注信息....." },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "submit" }, [
      _c(
        "p",
        { staticStyle: { cursor: "pointer" }, on: { click: _vm.submintEvent } },
        [_vm._v("提交退货")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("*")]), _vm._v("实退金额")])
  },
]
render._withStripped = true

export { render, staticRenderFns }